<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
-->
<div class="container vh-100 d-flex flex-column align-items-center justify-content-center text-center no-user-select">
    <div class="card shadow-lg p-4" style="max-width: 400px; border-radius: 10px;">
        <!-- PIN Authentication Flow (JwtAndPin) -->
        <ng-container *ngIf="showPinField; else googleLoginFlow">
            <h5 class="mb-3 text-theme">Enter PIN to Continue</h5>
            
            <form [formGroup]="pinForm" (ngSubmit)="submitPin()">
                <div class="mb-3">
                    <div class="input-group">
                        <input 
                            id="pinInput"
                            [type]="showPin ? 'text' : 'password'" 
                            class="form-control" 
                            placeholder="Enter PIN"
                            formControlName="pin"
                            autocomplete="off"
                            maxlength="8">
                        <button 
                            type="button" 
                            class="btn btn-pin-toggle" 
                            (click)="togglePinVisibility()"
                            title="Toggle PIN visibility">
                            <i [class]="showPin ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                        </button>
                    </div>
                    <small class="text-danger" *ngIf="pinForm.get('pin')?.invalid && pinForm.get('pin')?.touched">
                        PIN is required
                    </small>
                </div>
                <button 
                    type="submit" 
                    class="btn btn-theme w-100 py-2"
                    [disabled]="!pinForm.valid || isSubmitting">
                    <span *ngIf="!isSubmitting">Submit PIN</span>
                    <span *ngIf="isSubmitting">
                        <i class="spinner-border spinner-border-sm me-2"></i>Verifying...
                    </span>
                </button>
            </form>

            <hr>
            <small class="text-secondary">
                <p>Enter the PIN that was provided to access this exclusive gallery.</p>
            </small>
        </ng-container>

        <!-- Google Login Flow (default/public) -->
        <ng-template #googleLoginFlow>
            <h5 class="mb-3 text-theme">Sign in to Continue</h5>
            <p class="text-muted">Please sign in with Google to continue.</p>
            <button class="btn btn-theme w-100 d-flex align-items-center justify-content-center py-2"
                (click)="loginWithGoogle()">
                <i class="fab fa-google me-2"></i> Sign in with Google
            </button>
            <hr>
            <small class="text-secondary text-start">
                By signing in, you acknowledge that
                <ul>
                    <li>Your name and email address will be collected.</li>
                    <li>This is a public space, and any photos uploaded and posts you create will be visible to other logged-in users within this website.</li>
                </ul>
            </small>
        </ng-template>
    </div>
</div>